import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { APPROVE_PROPOSAL_URL } from './action-api-urls';
import { ActionProposal } from './action-types';

export interface ApproveActionRequest {
  notes?: string;
}

export interface ApproveActionResponse {
  success: boolean;
  message: string | null;
  data: ActionProposal | null;
}

export default async function approve_action_api_call(
  proposalId: string,
  approveData?: ApproveActionRequest
): Promise<ActionProposal | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: APPROVE_PROPOSAL_URL(shopSlug, proposalId),
      method: 'POST',
      body: JSON.stringify(approveData || {}),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'APPROVE_ACTION_PROPOSAL';
    const customMsg = 'Action proposal approved successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false
    );

    const response: ApproveActionResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during approve action proposal request');
    return null;
  }
}
